import { takeLatest, all, call, put } from "typed-redux-saga";

import { BRAND_ACTION_TYPES } from "./brand.types";
import { brandActions } from "./brand.slice";
import { apiRequest } from "lib/api/apiClient";

export function* fetchData() {
  yield* put(brandActions.setIsLoading(true));
  try {
    const link = "/api/v1/vendor/brands";
    const data = yield* call(apiRequest, link);
    if (!data) return;
    yield* put(brandActions.setAllBrand(data));
  } catch (error) {
    console.log(error as Error);
  } finally {
    yield* put(brandActions.setIsLoading(false));
  }
}

export function* onFetchData() {
  yield* takeLatest(BRAND_ACTION_TYPES.FETCH_ALL_DATA, fetchData);
}

export function* brandSagas() {
  yield* all([call(onFetchData)]);
}
